module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/icon-b340bda9d9bd1a7bda31e6403aa3876f.png";